import { render, staticRenderFns } from "./Percorso.vue?vue&type=template&id=646c674f&scoped=true&"
import script from "./Percorso.vue?vue&type=script&lang=js&"
export * from "./Percorso.vue?vue&type=script&lang=js&"
import style0 from "./Percorso.vue?vue&type=style&index=0&id=646c674f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "646c674f",
  null
  
)

export default component.exports